import { Language } from '../translations'

export const workHistoryTranslations: Record<string, Record<Language, string>> = {
  // Work history related translations
  addWorkHistory: {
    en: 'Add Work History',
    fi: 'Lisää työhistoria'
  },
  editWorkHistory: {
    en: 'Edit Work History',
    fi: 'Muokkaa työhistoriaa'
  },
  company_name: {
    en: 'Company',
    fi: 'Yritys'
  },
  position: {
    en: 'Job title',
    fi: 'Tehtävänimike'
  },
  startDate: {
    en: 'Start Date',
    fi: 'Aloituspäivä'
  },
  endDate: {
    en: 'End Date',
    fi: 'Päättymispäivä'
  },
  present: {
    en: 'Present',
    fi: 'Nykypäivä'
  },
  update: {
    en: 'Update',
    fi: 'Päivitä'
  },
  workHistoryDeleted: {
    en: 'Work history entry deleted successfully',
    fi: 'Työ poistettu onnistuneesti'
  },
  workHistoryUpdated: {
    en: 'Work history entry updated successfully',
    fi: 'Työ päivitetty onnistuneesti'
  },
  workHistoryAdded: {
    en: 'Work history entry added successfully',
    fi: 'Työ lisätty onnistuneesti'
  },
  noWorkHistory: {
    en: 'No work history entries',
    fi: 'Ei työhistoriatietoja'
  },
  confirmDeleteWorkHistory: { 
    en: "Are you sure you want to delete this work history entry?", 
    fi: "Haluatko varmasti poistaa tämän työn?" 
  },
  selectMonth: {
    en: 'Select Month',
    fi: 'Valitse kuukausi'
  }
};